import { setStoredSession } from '../../../utils/session';

// Positions that supervise a whole branch or the whole company rather than sitting at
// a counter. They have no counter of their own, so the queue screens ask for every
// group (-1 within one outlet, -2 across all of them) instead of one counter's group.
const BRANCH_WIDE_POSITIONS = ['Branch Administrator', 'Receptionist'];
const COMPANY_WIDE_POSITIONS = ['Kerawang Administrator', 'HQ Administrator'];

function counterGroupIdFor(staffDetail) {
  if (staffDetail.hasCounter) {
    return staffDetail.counterDetail.counterGroupDetail.id;
  }
  const position = staffDetail.staffPosition.name;
  if (BRANCH_WIDE_POSITIONS.includes(position)) return -1;
  if (COMPANY_WIDE_POSITIONS.includes(position)) return -2;
  return null;
}

export default {
  SET_user: (state, data) => {
    const staffDetail = data.userDetail.staffDetail;

    // userId is the PrimeUser id. /api/staff/logged resolves its argument against
    // PrimeUser, so this is the id the logged-profile lookup needs - not the Staff id.
    setStoredSession({
      token: data.token,
      userId: data.userDetail.id,
      userName: data.userDetail.userName,
      isStaff: data.userDetail.isStaff,
      firstName: data.userDetail.firstName,
      lastName: data.userDetail.lastName,
      staffPosition: staffDetail.staffPosition.name,
      counterId: staffDetail.hasCounter ? staffDetail.counterDetail.id : null,
      counterGroupId: counterGroupIdFor(staffDetail),
    });
  },
};
